import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
const LayoutContext = createContext({
    setPageTitle: () => void 0,
});
export function LayoutProvider({ appName, children }) {
    const [pageTitle, setPageTitle] = useState();
    useEffect(() => {
        document.title = pageTitle ? `${pageTitle} | ${appName}` : appName;
    }, [pageTitle]);
    const value = useMemo(() => ({ setPageTitle }), []);
    return (React.createElement(LayoutContext.Provider, { value: value }, children));
}
export const useLayoutContext = () => {
    const value = useContext(LayoutContext);
    if (!value) {
        throw new Error("Cannot find layout context. Are you missing a LayoutProvider in your component tree?");
    }
    const { setPageTitle } = value;
    return {
        setPageTitle,
    };
};
//# sourceMappingURL=layout-context.js.map